"use client";
import React, { useState } from 'react';
import { Send, User, Phone, Building2, Zap, CheckCircle } from 'lucide-react';
import { submitEnquiry } from '../utils/formSubmission';

const EnquiryForm = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const formData = new FormData(e.target);
        const data = {
            name: formData.get('name'),
            phone: formData.get('phone'),
            subject: "Enquiry from " + formData.get('dealership'),
            email: "", 
            message: "Dealership Name: " + formData.get('dealership'),
        };

        try {
            await submitEnquiry(data);
            setSubmitted(true);
            e.target.reset();
            setTimeout(() => setSubmitted(false), 6000);
        } catch (error) {
            console.error("Submission failed", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="w-full max-w-[1400px] mx-auto px-6">
            <form onSubmit={handleSubmit} className="bg-white rounded-[2rem] shadow-[0_20px_60px_rgba(0,0,0,0.15)] flex flex-col lg:flex-row items-stretch overflow-hidden p-2 border border-slate-100">

                {/* Left Section */}
                <div className="bg-[#0F172A] text-white px-8 py-5 flex flex-col justify-center rounded-l-[1.5rem] min-w-[220px]">
                    <div className="flex items-center gap-2 text-brand mb-0.5">
                        <Zap size={12} className="fill-brand" />
                        <span className="text-[9px] font-black uppercase tracking-widest">Instant Response</span>
                    </div>
                    <p className="text-lg font-bold tracking-tight">Request Pricing</p>
                </div>

                {/* Inputs */}
                {submitted ? (
                    <div className="flex-1 flex items-center justify-center p-3 text-emerald-600 font-bold gap-2">
                        <CheckCircle size={20} /> Request Sent Successfully!
                    </div>
                ) : (
                    <>
                        <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-3 p-3">
                            <div className="relative group">
                                <User className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-brand transition-colors" size={16} />
                                <input required name="name" type="text" placeholder="Full Name" aria-label="Full Name" className="w-full h-full bg-slate-50 border border-transparent focus:border-brand/20 focus:bg-white rounded-xl pl-11 pr-4 py-3.5 text-slate-900 outline-none text-sm font-semibold" />
                            </div>
                            <div className="relative group">
                                <Phone className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-brand transition-colors" size={16} />
                                <input required name="phone" type="tel" placeholder="Phone Number" aria-label="Phone Number" className="w-full h-full bg-slate-50 border border-transparent focus:border-brand/20 focus:bg-white rounded-xl pl-11 pr-4 py-3.5 text-slate-900 outline-none text-sm font-semibold" />
                            </div>
                            <div className="relative group">
                                <Building2 className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-brand transition-colors" size={16} />
                                <input required name="dealership" type="text" placeholder="Dealership Name" aria-label="Dealership Name" className="w-full h-full bg-slate-50 border border-transparent focus:border-brand/20 focus:bg-white rounded-xl pl-11 pr-4 py-3.5 text-slate-900 outline-none text-sm font-semibold" />
                            </div>
                        </div>

                        {/* Submit */}
                        <div className="p-3 flex items-center">
                            <button disabled={isSubmitting} type="submit" className="w-full lg:w-fit bg-brand hover:bg-[#0F172A] text-white font-black px-10 py-4 rounded-xl transition-all flex items-center justify-center gap-3 whitespace-nowrap shadow-lg shadow-brand/10 uppercase text-[11px] tracking-widest disabled:opacity-50">
                                {isSubmitting ? 'Sending...' : 'Send Enquiry'} <Send size={14} />
                            </button>
                        </div>
                    </>
                )}
            </form>
        </div>
    );
};

export default EnquiryForm;